import React, { lazy } from 'react';
import { useInView } from '../hooks/useInView';
export function FrecuenciaSection() {
  const listItems = ['Hemispheric Synchronization.', 'Elimination of Financial Cortisol.', 'Activation of Business Intuition.'];
  const [imgRef, imgInView] = useInView();
  const [textRef, textInView] = useInView();
  return <section id="la-frecuencia" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-[#0A0A0B] relative border-t border-white/5" data-id="element-76">
      <div className="max-w-[1200px] mx-auto" data-id="element-77">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-center" data-id="element-78">
          {/* Image */}
          <div ref={imgRef} className={`order-2 lg:order-1 relative will-animate animate-slideLeft ${imgInView ? 'is-visible' : ''}`} data-id="element-79">
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/La_Frecuencia_888_Visualizacion_del_Sonido.png?v=1775420936&width=600&crop=center" srcSet="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/La_Frecuencia_888_Visualizacion_del_Sonido.png?v=1775420936&width=400 400w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/La_Frecuencia_888_Visualizacion_del_Sonido.png?v=1775420936&width=600 600w" sizes="(max-width: 1024px) 100vw, 50vw" alt="Cymatics visualization of the 888Hz frequency showing sacred geometry patterns" width={600} height={400} loading="lazy" decoding="async" className="w-full rounded-xl border border-gold/30 shadow-[0_0_40px_rgba(212,175,55,0.1)] relative z-10 aspect-[3/2]" data-id="element-80" />
          </div>

          {/* Text */}
          <div ref={textRef} className={`order-1 lg:order-2 text-center lg:text-left will-animate animate-slideRight ${textInView ? 'is-visible' : ''}`} data-id="element-81">
            <h2 className="font-serif text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-82">
              The Order of <br className="hidden lg:block" data-id="element-83" />
              <span className="text-gold" data-id="element-84">Liquid Gold</span>
            </h2>

            <p className="text-lg opacity-90 leading-relaxed mb-8" data-id="element-85">
              The 888Hz frequency generates sacred geometry patterns in the
              water of your cells. Where there was once chaos and debt, The 888
              Code introduces{' '}
              <strong className="text-white font-bold" data-id="element-86">Order and Flow</strong>.
            </p>

            <ul className="space-y-4 text-left inline-block lg:block" data-id="element-87">
              {listItems.map((item, index) => <li key={index} className={`flex items-center text-white font-semibold text-[15px] opacity-90 will-animate animate-fadeIn delay-${(index + 3) * 100} ${textInView ? 'is-visible' : ''}`} data-id="element-88">
                  <span className="text-gold font-black text-xs mr-4 tracking-wider" data-id="element-89">
                    888
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}